import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter } from "react-router-dom";
import ScreenFixedProvider from "../src/components/context/ScreenFixedProvider";
import { ParallaxProvider } from "react-scroll-parallax";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ScreenFixedProvider>
      <BrowserRouter>
        <GoogleReCaptchaProvider reCaptchaKey="6LfyTN4jAAAAAHPr6uvLAGELWJ616o4s-37vtS9Q">
          <ParallaxProvider>
            <App />
          </ParallaxProvider>
        </GoogleReCaptchaProvider>
      </BrowserRouter>
    </ScreenFixedProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
